document.addEventListener("DOMContentLoaded", function() {

  function checkViewportWidth() {
    var mediaDs = document.querySelector(".deferred-media.ds--view video");
    var mediaMb = document.querySelector(".mobile-video video");

    console.log(mediaDs);
    console.log(mediaMb);
    
    if (window.innerWidth < 543) {
      mediaDs.muted = true;
      mediaMb.play();
    } else {
      mediaMb.pause();
      mediaMb.currentTime = 0;
      mediaMb.load();
      mediaMb.muted = true;
    }
  }
  
  // function checkViewportWidth() {
  //   // Look specifically for a <div> with the class "mobile-view"
  //   var mobileDiv = document.querySelector("div.mobile-view");
  //   var desktopDiv = document.querySelector("div.desktop-view");
    
  //   // Ensure mobileDiv exists before proceeding
  //   if (mobileDiv) {
      
  //     var mediaItem = mobileDiv.querySelector(".video-section__media");
  //     var dsMediaItem = desktopDiv.querySelector(".video-section__media");
      
  //     var mediaItemVideo = mediaItem.querySelector("video");
  //     var dsMediaItemVideo = dsMediaItem.querySelector("video");
      
  //     console.log(mediaItemVideo)
  //     // Check that mediaItem exists
  //     if (mediaItem) {
  //       if (window.innerWidth < 543) {
  //         mediaItemVideo.play();

  //         dsMediaItemVideo.pause();
  //         dsMediaItemVideo.currentTime = 0;
  //         // dsMediaItemVideo.load();
  //       } 
  //       else {
  //         dsMediaItemVideo.play();
          
  //         mediaItemVideo.pause();
  //         mediaItemVideo.currentTime = 0;
  //         // mediaItemVideo.load();
  //       }
  //     }
  //   }
  // }

  // Initial check after document load
  checkViewportWidth();

  // Listen for resize events
  window.addEventListener("resize", checkViewportWidth);
});
